import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import theme from './theme';
import { AuthProvider } from './auth';
import { registerPwaUpdates } from './lib/pwaUpdate';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    registerPwaUpdates({
      onUpdateAvailable: (apply) => {
        // Auto-apply new SW so Add-to-Home phones get ads/UI fixes without Safari hard refresh.
        try {
          apply();
        } catch {
          /* ignore */
        }
      },
    });
  });
}
